












































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {alert} from 'devextreme/ui/dialog';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';
import DSearchBox from '@/components/DSearchBox/search-box.vue';

import DxPopup from 'devextreme-vue/popup';
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxValidationGroup } from 'devextreme-vue';
import DxList from 'devextreme-vue/list';

import _ from 'lodash';
import UserManagerService, {AdUserEntity, User} from '@/services/data/user_manager';
import RoleManagerService from '@/services/data/role_manager';
import AuthService from '@/services/auth_service';
import {EcoFilialSelectionType, FilialNodeTree} from "@/services/models-service";


@Component({
  name: 'ADUserEditPopup',
  components: {
    DxPopup,
    DxScrollView,
    DxValidationGroup,
    DTextbox,
    DButton,
    DSelectbox,
    TreeDropDownBox,
    DSearchBox,
    DxList,
  }
})

export default class extends Vue {
  @Prop({default: () => []}) selectionEmpty!: EcoFilialSelectionType[];

  public service = UserManagerService;
  public roleService = RoleManagerService;
  public authService = AuthService;
  public entity: User = new User();

  //  Список всех пользователей Active direcory
  private adUsersDS: AdUserEntity[] = [];

  private currentADUser: AdUserEntity | null = null;

  private adSelectionData: EcoFilialSelectionType[] = [];

  // строка для запроса фильтрации пользователей AD по ФИО или логину
  private filterString: any[] = [];

  public admin_selected: boolean = false;

  private selectedItemList: AdUserEntity[] = [];

  private fileManagerOptions = [
    { id: 'forbidden', name: 'Запрещен доступ' },
    { id: 'read_only', name: 'Разрешен только просмотр' },
    { id: 'read_and_edit', name: 'Разрешен просмотр и редактирование' }
  ];

  @Watch('selectedItemList', { deep: true })
  onCurrentAdUserUidChanged() {
    // текущий выбранный элемент списка
    if (!this.service.edit_popup.edit_mode) {
      const value = (this.selectedItemList.length) ? this.selectedItemList[0] : null;
      if (value) {
        this.entity.ad_guid = value.objectGUID;
        this.currentADUser = value; 
        this.entity.full_name = this.currentADUser.cn;
        this.entity.email = this.currentADUser.mail || '';
        this.entity.login = this.currentADUser.sAMAccountName || '';
      }
    }
  }

  get adminSelected() {
    return this.admin_selected;
  }

  @Watch('entity.role')
watchRole() {
  // Обновляем admin_selected при изменении роли
  this.admin_selected = (this.entity.role === this.authService.adminRoleId);
  
  // Если администратор выбран, очищаем выбор тепловых узлов
  if (this.admin_selected) {
    this.entity.id_eco_heat_node = null;
    this.entity.eco_heat_nodes = [];
  }
}

  @Watch('filterString')
  onFilterStringChange() {
    this.updateAdUsers();
  }

  async created() {
    if (this.service.edit_popup.edit_mode) {
      this.entity = _.cloneDeep(this.service.selected_row);
      this.entity.eco_heat_nodes = this.service.selected_row.eco_heat_nodes.map((x: any): number => x.id_eco_heat_node)

      this.adSelectionData = this.selectionEmpty.map(sel => {
        let filialCheck = true; // Сосотояние "выбран" для узла верхнего уровня дерева - филиала
        const nodes = sel.nodes.map( n => {
          if (this.entity.eco_heat_nodes.includes(n.id)) {
            return { ...n, check: true };
          } else {
            // Если хотя бы 1 узел в филиале не выбран, для него указывается состояние "не выбран"
            filialCheck = false;
            return { ...n, check: false };
          }
        });
        return { ...sel, filialCheck, nodes };
      })
    } else {
      this.entity = new User();
      this.adSelectionData = _.cloneDeep(this.selectionEmpty);
    }
  }

  onShow() {
    this.filterString= [];
    if (this.service.edit_popup.edit_mode ) {
      this.updateAdUsers();
    } else {

    }
  }

  private async updateAdUsers() {
    this.service.getAdUsersList(JSON.stringify(this.filterString)).then(resp => {
      if (resp.data) {
        // Показывать в выборе имена только тех пользователей AD, которые не синхронизированы с пользователями ТПлюс
        // + в режиме редактирования пользователя показывать пользователю свою запись AD
        this.adUsersDS = resp.data.filter(adUser => {
          if (!adUser.is_selected) {
            return true;
          }
          if (this.service.edit_popup.edit_mode && this.service.selected_row.ad_guid && this.service.selected_row.ad_guid === adUser.objectGUID) {
            return true;
          }
          return false;
        });
        if (this.entity.ad_guid)
        {
          this.currentADUser = this.adUsersDS.find(u => u.objectGUID === this.entity.ad_guid) || null;
        }
      } else {
        this.currentADUser = null;
      }
    })
  }

  onClose() {
    this.service.setEditPopupVisible(false);
    this.service.setEditPopupMode(false);
  }

  nodeSelectionChange(nodeIds: any) {
    this.entity.eco_heat_nodes = nodeIds.nodes;
    console.log('this.entity.eco_heat_nodes', this.entity.eco_heat_nodes);
  }

  async onOk(e: any) {
    const vg = (this.$refs['userEditForm'] as any).instance;
    const result = vg.validate();
    if (result.isValid) {
      try {
        if (!this.service.edit_popup.edit_mode && this.currentADUser?.is_selected) {
          await alert("Выбранный пользователь Active Directory уже связан с пользователем системы", 'Ошибка');
          return;
        }

        if (!this.admin_selected && (_.isNil(this.entity.eco_heat_nodes) || this.entity.eco_heat_nodes.length === 0)) {
          await alert("Для оператора необходимо указать тепловые узлы", 'Ошибка');
          return;
        }

        const clone: any = _.cloneDeep(this.entity)
        if (clone.eco_heat_nodes && clone.eco_heat_nodes.length !== 0) {
            let eco_heat_nodes: any = _.clone(clone.eco_heat_nodes);

            clone.eco_heat_nodes = [];
            eco_heat_nodes.forEach((x: any) => {
              clone.eco_heat_nodes.push({id_eco_heat_node: x})
            })
        }
        clone.password = 'password is present'
        const resp = await this.service.saveUser(clone);
        try { await this.service.userDataSource.reload(); } catch (e) { if (e !== 'canceled') throw e; }
        this.service.setCurrentRow(null);
        this.onClose();

      } catch (e) {
        console.log(e)
      }
    } else {
      const errors = result.brokenRules.map((item: any) => item.message);
      if (errors.length > 0) {
        await alert(errors.join('<br>\n'), 'Ошибка');
      }
    }
  }

}
